import TextInputField from '../../fields/text-input-field/text-input-field.component'

type AddTaxFormProps = {
  prefilledLight?: boolean
}

const AddTaxForm = ({ prefilledLight }: AddTaxFormProps) => {
  return (
    <>
      <TextInputField
        name="taxName"
        label="Tax Name"
        prefilledLight={prefilledLight}
      />
      <TextInputField
        name="taxNumber"
        label="Tax Number"
        prefilledLight={prefilledLight}
      />
      <TextInputField
        name="taxPercentage"
        label="Tax Percentage"
        prefilledLight={prefilledLight}
      />
    </>
  )
}

export default AddTaxForm
